<template>
  <div id="app">
    <transition name="fade">
      <div class="header" ref="header" v-show="!isShow">
        <div class="logo_img" @click="logoClick">
          <div style="height: 83px;width: 30%;padding-left: 15px">
            <div class="header-logo">
              <a href="/"><img id="header-img" src="../assets/logo.png" style="position: relative"></a>
            </div>
          </div>
          <div style="display:flex; height: 100%;width: 70%;">
            <div class="header-important">
              <div class="company_name">浙江宸舟科技有限公司</div>
<!--              <div class="font_size font_weight">阡陌交通，鸡犬相闻<br>人生天地间,忽如远行客</div>-->
<!--              <div class="company_name">·阡客</div>-->
            </div>
          </div>
        </div>
        <div class="menu_index">
          <!-- web端菜单导航 自己换div做吧，好控制：你也可以删除这个mode="horizontal" 剩下的自己改样式-->
          <el-menu v-if="seen" :default-active="activeIndex" menu-trigger="click"
                   style="height: 100%; border:0;display: flex;align-items: center;"  @select="handleSelect">
            <el-menu-item index="1" class="header-title" style="padding-left: 20px; margin-left: 100px;">关于我们</el-menu-item>
            <el-menu-item index="2-1" class="header-title">阡客介绍</el-menu-item>
            <!--                  <el-submenu index="2">-->
            <!--                        <template slot="title"><span style="font-size: 16px;">阡客介绍</span></template>-->
            <!--                        <el-menu-item index="2-1">产品微观</el-menu-item>-->
            <!--                    </el-submenu>-->
  <!--          <el-menu-item index="4" class="header-title">企业社会责任</el-menu-item>-->
  <!--          <el-menu-item index="5" class="header-title">加入我们</el-menu-item>-->
          </el-menu>
          <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
          <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
                   style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
            <el-submenu index="1" class="header-title mobile_menu">
              <template slot="title">{{ currentMenu }}</template>
              <el-menu-item index="1" class="header-title">关于我们</el-menu-item>
              <el-menu-item index="3" class="header-title">产品与解决方案</el-menu-item>
              <el-menu-item index="4" class="header-title">企业社会责任</el-menu-item>
              <el-menu-item index="5" class="header-title">加入我们</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>

        <!--电话-->
        <div class="tell" style="margin-top: 12px">
          <div class="tell_up">
            <div class="tell-left" index="0"><img src="../assets/tell.png"/></div>
            <div class="tell-right font_weight"><span>0573-82872737</span></div>
          </div>
          <div class="tell_down">
            <div class="email_img"><img src="../assets/other/email.png"/></div>
            <p class="Email font_weight">chenwenqing@chaincotec.com</p>
          </div>
        </div>
      </div>
    </transition>
    <div class="container" style="clear: both;">
      <router-view></router-view>
    </div>

    <div style="width: 90%;margin: 3% auto;">
      <div style="height:1px;padding:0;background-color:#999;">
      </div>
    </div>
    <div style="width: 90%;margin: 20px auto;">
      <el-row>
        <el-col>
          <div style="margin: auto;" class="footer_font">
            <a href="https://beian.miit.gov.cn" target="_blank">All Right Reserved.浙江ICP备2021011543号-1</a>
          </div>
          <div style="margin: auto;" class="footer_font">
            浙江宸舟科技有限公司
            <p>地址:浙江省嘉兴市秀洲区高照街道北科建创新园22撞B座303-4室</p>
          </div>
        </el-col>
        <transition name="fade">
          <div class="code_App" v-show="isShow">
            <div class="code_up"></div>
            <div class="code"><img :src="company.qrcode"/></div>
            <div class="App">下载阡客APP</div>
          </div>
        </transition>
      </el-row>
    </div>
    <transition name="fade">
      <div v-show="isShow" id="back_to_top" ref="btn" @click="backTop" style="display: none;">
        <p style="font-size: 0.625em; font-weight: bold">TOP</p>
        <img src="../assets/other/launch.png" style="height: 45px;width: 35px"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      activeIndex: '1',
      company: {
        qrcode: require("../assets/二维码.png"),
      },
      scroll: '',
      timer: '',
      seen: true,
      currentMenu: '首页',
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      switch (key) {
        case '1':
          this.$router.push({name: "Index"});
          break;
        case '2-1':
          this.$router.push({name: "Product"});
          break;
        case '4':
          this.$router.push({name: "Responsibility"});
          break;
        case '5':
          this.$router.push({name: "Main"});
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case '1':
          this.$router.push({name: "Index"});
          this.currentMenu = '首页';
          break;
        case '3':
          this.$router.push({name: "Index"});
          window.location.hash = "#产品特点";
          this.currentMenu = '首页';
          break;
        case '4':
          this.$router.push({name: "Index"});
          window.location.hash = "#合作伙伴";
          this.currentMenu = '首页';
          break;
        case '5':
          this.$router.push({name: "Index"});
          window.location.hash = "#关于我们";
          this.currentMenu = '首页';
          break;
      }
    },
    //handleScroll() 可接收参数：program, index
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 500) {  //判断滚动后高度超过400px,就显示
        // this.$refs.header.style.display = 'none'
        // this.$refs.btn.style.display = 'block'
        this.isShow = true
      } else {
        // this.$refs.btn.style.display = 'none'
        // this.$refs.header.style.display = ''
        this.isShow = false
      }
    },
    backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer)
        }
      }, 30)
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({name: "Index"});
      this.currentMenu = '首页';
    },

  },
  mounted() {
    this.menuSeen()
    window.addEventListener('scroll', this.handleScroll)
  },
}
</script>

<style scoped>
    .logo_img {
      display: flex;
      /*padding-top: 4px;*/
      width: 30%;
    }

    #back_to_top {
      z-index: 3;
      position: fixed;
      bottom: 50px;
      right: 30px;
      cursor: pointer
    }

    .header-title {
      margin: 0 25px;
      font-size: 18px;
      font-family: 微软雅黑;
    }

    /********************电话********************/
    .tell {
      width: 20%;
    }

    .tell_up {
      display: flex;
    }

    .tell-left > img {
      width: 38px;
    }

    .tell_down {
      display: flex;
    }

    .email_img {
      margin-top: -1%;
    }

    .email_img > img {
      width: 38px;
    }

    .Email {
      margin-top: 2%;
      white-space: nowrap;
      font-family: 华文宋体;
    }

    .tell-right {
      padding-top: 4%;
      font-family: 华文宋体;
    }

    .company_name {
      font-family: 楷体;
      font-weight: bold;
      font-size: 1.3em;
      align-self: center;
    }

    .font_weight {
      font-weight: bold;
    }

    .font_size {
      font-size: 15px;
      text-align: center;
      font-family: 楷体;
    }

    .footer_font {
      font-family: 微软雅黑;
      font-size: 1em;
      text-align: center;
    }

    .code_up {
      width: 170px;
      height: 170px;
      position: fixed;
      background-color: #fff;
      border-radius: 10px;
      bottom: 20px;
      z-index: -1;
      margin-left: 5.4%;
    }

    .code_App {
      position: fixed;
      width: 22%;
      height: 251px;
      z-index: 10;
      bottom: 0px;
      margin-left: 1000px;
    }

    .code {
      width: 320px;
      height: 320px;
    }

    .code > img {
      width: 100%;
      height: 100%;
    }

    .App {
      font-family: 华文宋体;
      font-weight: bold;
      text-align: center;
      width: 320px;
      position: fixed;
      bottom: 20px;
      background-color: rgba(240, 240, 240, 0.3);
    }

    .menu_index {
      display: flex;
      width: 40%;
    }

    .header {
      justify-content: space-between;
      z-index: 3;
      background-color: #ffffff;
      position: fixed;
      display: flex;
      width: 100%;
      height: 90px;
    }

    @media screen and (max-device-width: 415px) {
      .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
      }

      #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
      }

      .footer_font {
        font-size: 0.875em;
      }

      #menu_index {
        float: right;
        width: auto;
        height: 100%
      }

      .mobile_menu {

      }
    }

    #header-img {
      width: 100%;
    }

    .header-logo {
      margin: 2px auto;
      cursor: pointer;
      width: 70%;
      align-self: center;
    }

    .header-important {
      margin: 0 auto;
      width: 100%;
      display: flex;
      align-self: center;
    }

    a {
      text-decoration: none;
    }

    a:visited {
      text-decoration: none;
    }

    a:hover {
      text-decoration: none;
    }

    a:active {
      text-decoration: none;
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.2s
    }
    .fade-enter, .fade-leave-to {
      opacity: 0
    }
</style>